export default __webpack_public_path__ + "static/media/club-home-page.27a8b085.png";